import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  instructorsTitle: {
    id: 'course-authoring.schedule-section.instructors.title',
    defaultMessage: 'Instructors',
  },
  instructorsDescription: {
    id: 'course-authoring.schedule-section.instructors.description',
    defaultMessage: 'Add details about the instructors for this course',
  },
  instructorAdd: {
    id: 'course-authoring.schedule-section.instructors.add-instructor',
    defaultMessage: 'Add Instructor',
  },
});

export default messages;
